<template>
  <div
    :class="[
      'tkSearchConditionBox',
      { '-border': border },
    ]"
  >
    <template v-if="url">
      <tk-link
        :class="[
          'tkSearchConditionBox_changeBtn',
          `-${buttonTheme}`,
        ]"
        :href="url"
      >
        <span
          v-if="buttonText"
          class="tkSearchConditionBox_buttonText"
        >
          {{ buttonText }}
        </span>
        <template v-else>
          <span class="tkSearchConditionBox_pcShowText">条件</span>
          <span class="tkSearchConditionBox_buttonText">変更</span>
        </template>
      </tk-link>
    </template>
    <template v-else>
      <tk-button
        :class="[
          'tkSearchConditionBox_changeBtn',
          `-${buttonTheme}`,
        ]"
        :disabled="disabled"
        @click="$emit('execute')"
      >
        <span
          v-if="buttonText"
          class="tkSearchConditionBox_buttonText"
        >
          {{ buttonText }}
        </span>
        <template v-else>
          <span class="tkSearchConditionBox_pcShowText">条件</span>
          <span class="tkSearchConditionBox_buttonText">変更</span>
        </template>
      </tk-button>
    </template>
    <div
      class="tkSearchConditionBox_placeArea"
    >
      <tk-icon
        class="tkSearchConditionBox_icon"
        name="place_blue"
        :color="iconColor"
      />
      <p class="tkSearchConditionBox_text">{{ placeText }}</p>
    </div>
    <div class="tkSearchConditionFlg_text">{{ conditionFlgText }}</div>
    <div
      class="tkSearchConditionBox_dateAndPeopleArea">
      <tk-icon
        class="tkSearchConditionBox_icon"
        name="hotel_blue"
        :color="iconColor"
      />
      <p class="tkSearchConditionBox_text">{{ dateAndPeopleText }}</p>
    </div>
  </div>
</template>

<script>
import compact from 'lodash.compact'
import { TkLink, TkIcon, TkButton } from '@ota-frontend/ui'

export default {
  name: 'TkSearchConditionBox',
  components: {
    TkLink,
    TkIcon,
    TkButton,
  },
  props: {
    depPlace: {
      type: String,
      default: undefined,
    },
    destPlaces: {
      type: Array,
      default: () => [],
    },
    depDate: {
      type: String,
      default: undefined,
    },
    duration: {
      type: Number,
      default: undefined,
    },
    peopleNum: {
      type: Number,
      default: undefined,
    },
    url: {
      type: String,
      default: undefined,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    iconColor: {
      type: String,
      default: undefined,
    },
    buttonText: {
      type: String,
      default: undefined,  // デフォルトで PC: "条件変更"、SP: "変更"
    },
    buttonTheme: {
      type: String,
      default: 'default',  // default: 四角ボタン、round-corners: 丸角ボタン
    },
    border: {
      type: Boolean,
      default: false,  // false(デフォルト): 枠線なし, true: 枠線あり
    },
  },
  data() {
    return {
      conditionFlg: '他の都市に行くツアーも含めて表示',
      params: {} // `params` を初期化
    }
  },
  computed: {
    placeText() {
      const departurePlace = (this.depPlace || '')
        .replace(/東京（成田・羽田）/g, '東京')
        .replace(/大阪（関空・伊丹）/g, '大阪')
      return compact([
        departurePlace ? `${departurePlace}発` : '',
        this.destPlaces.length ? `${this.destPlaces.join('、')}行き` : '',
      ]).join(', ') || '未定'
    },
    dateAndPeopleText() {
      return compact([
        compact([
          this.depDate ? `${this.depDate}～` : '',
          this.duration ? `${this.duration}日間` : '',
        ]).join(''),
        this.peopleNum ? `${this.peopleNum}名/1室` : '',
      ]).join('　') || '未定'
    },
    conditionFlgText() {
      // クエリパラメータから `condition_flg` を取得
      const conditionFlg = this.$route.query.condition_flg;
      return conditionFlg ? '選択した都市だけに行くツアーのみ表示' : '他の都市に行くツアーも含めて表示';
    },
  },
  watch: {
    '$route.query.condition_flg'(newVal) {
      // URL パラメータが変更されたときに呼ばれる
      this.conditionFlg = newVal ? '選択した都市だけに行くツアーのみ表示' : '他の都市に行くツアーも含めて表示';
    }
  },
  mounted() {
    // コンポーネントがマウントされたときにも初期値を設定
    const conditionFlg = this.$route.query.condition_flg;
    this.conditionFlg = conditionFlg ? '選択した都市だけに行くツアーのみ表示' : '他の都市に行くツアーも含めて表示';
  },
  methods: {
    searchForm() {
      // `searchForm` メソッド内で URL パラメータを再確認
      const conditionFlg = this.$route.query.condition_flg;
        this.conditionFlg = conditionFlg ? '選択した都市だけに行くツアーのみ表示' : '他の都市に行くツアーも含めて表示';
    },
  },
}
</script>

<style scoped lang="scss">
  .tkSearchConditionBox {
    position: relative;
    padding: 5px 2%;
    background-color: #fff;
    font-family: 游ゴシック,YuGothic,ヒラギノ角ゴ ProN W3,Hiragino Kaku Gothic ProN,メイリオ,Meiryo,sans-serif;
    line-height: 1.3;

    &.-border {
      border: 1px solid #115da1;
    }
  }
  .tkSearchConditionBox_changeBtn {
    position: absolute;
    padding: 5px 10px 5px 10px;
    right: 2%;
    border: 1px solid #115da1;
    background-color: #115da1;
    color: #fff;
    font-weight: bold;
    font-size: 12px;
    font-family: inherit;
    text-decoration: none;
    line-height: inherit;
    outline-style: none !important;
    cursor: pointer;

    &.-default {
      border-radius: 0;
    }

    &.-round-corners {
      border-radius: 3px;
    }

    &:hover {
      opacity: .6;
    }
  }
  .tkSearchConditionBox_pcShowText {
    color: #fff;

    @media (max-width: 657px) {
      display: none;
    }
  }
  .tkSearchConditionBox_buttonText {
    color: #fff;
  }
  .tkSearchConditionBox_placeArea {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    font-weight: bold;
    font-size: 13px;
    color: #333;
    height: 27px;
    max-width: 85%;
  }
  .tkSearchConditionBox_dateAndPeopleArea {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    font-weight: bold;
    font-size: 13px;
    color: #333;
    height: 27px;
    max-width: 85%;
  }
  .tkSearchConditionBox_text {
    margin: 0 0 0 10px;
    max-width: 85%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .tkSearchConditionBox_icon {
    width: 20px;
  }
  .tkSearchConditionFlg_text{
    margin: 10px 0 10px 30px;
    font-size: 13px;
    font-weight: 700;
  }
</style>
